export default "__VITE_ASSET__vNeKcNBP__"